




import { Component, Vue } from 'vue-property-decorator';
import {
  changePageBackground,
  changePageWidth,
  fetchPageHistoryContents,
  fetchPageHistoryList,
  updatePageContents,
} from './api/content';
import {
  previewPageContents,
  publishPageContents,
} from './api/deploy';
import {
  fetchPolicyShopinfo,
} from './api/design';
import {
  deleteImage,
  deleteImages,
  fetchImageList,
  getImageFilename,
  getImageUrl,
  uploadImages,
} from './api/adminImage';
import {
  initialize,
  logout,
} from './api/others';
import {
  createPage,
  deletePage,
  updatePage,
  updateMenus,
} from './api/page';
import {
  changeFontFamily,
  changeTemplateSkin,
  fetchFontList,
  fetchPrimaryShopinfo,
  setFixedTemplate,
} from './api/shop';
import { fetchProductList } from './api/products';

declare global {
  interface Window {
    wysiwygContentsEditor: any;
  }
}

const loadScripts = async (srces: string[]): Promise<void> => {
  return new Promise((resolve, reject) => {
    const loadedSrces: string[] = [];

    const onLoadScript = (src: string) => {
      loadedSrces.push(src);

      if (loadedSrces.length === srces.length) {
        resolve();
      }
    };

    srces.forEach((src) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        onLoadScript(src);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => onLoadScript(src);
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(script);
    });
  });
};

const syncScriptGroups = [
  [
    '/standard/jquery-3.1.0.js',
    '/standard/wce/vue.min.js',
  ],
  [
    '/standard/wce/wce.umd.min.js',
    '/standard/ncp.common.js',
  ],
];

@Component({
  metaInfo: {
    link: [
      {
        rel: 'stylesheet',
        href: '/standard/wce/css/font.css',
      },
    ],
  },
})
export default class DesignEditor extends Vue {
  async mounted() {
    for (const scriptGroup of syncScriptGroups) {
      await loadScripts(scriptGroup);
    }

    window.wysiwygContentsEditor({
      el: this.$el,
      api: {
        // 초기 데이터 로딩
        initialize,
        // 이미지 업로드 요청
        uploadImages,
        // 업로드된 이미지 리스트 요청
        fetchImageList,
        // 이미지 삭제
        deleteImage,
        // 이미지 url요청
        getImageUrl,
        // 페이지 생성
        createPage,
        // 페이지 삭제
        deletePage,
        // 페이지 정보 업데이트
        updatePage,
        // 페이지 컨텐츠 업데이트
        updatePageContents,
        // 메뉴 업데이트
        updateMenus,
        // 샵 기본정보 요청
        fetchPrimaryShopinfo,
        // 샵 정책정보 요청
        fetchPolicyShopinfo,
        // 상품 리스트 요청
        fetchProductList,
        // 히스토리 목록 가져오기
        fetchPageHistoryList,
        // 히스토리 컨텐츠 가져오기
        fetchPageHistoryContents,
        // 페이지 게시하기
        publishPageContents,
        // 사용가능한 폰트목록 가저오기
        fetchFontList,
        // 페이지 배경 이미지 변경
        changePageBackground,
        // 페이지 넓이 변경
        changePageWidth,
        // 사용 폰트 변경
        changeFontFamily,
        // 미리보기
        previewPageContents,
        // 로그아웃
        logout,
        // 스킨 변경하기
        changeTemplateSkin,
        // 템플릿 변경하기
        setFixedTemplate,
        // 이미지 여러개를 한번에 삭제
        deleteImages,
        // 이미지 아이디로 부터 이미지 파일명을 리턴받음
        getImageFilename,
        // NOTE: 실제로 사용하지 않음
        // 튜토리얼 상태값 변경
        setShowTutorial: () => null,
      },
      options: {
        language: 'ko',
        // 한국향은 복합형, 좌측형이 없고 기본 상단형으로 적용.
        useLayoutType: false,
        // 한국향은 개선된 페이지 배경 정책을 사용하지 않고, 해더, 푸터, 메인 영역에 각각 따로 적용되도록 유지
        useSeperatePageBackgroundForHeaderFooter: true,
        // 템플릿 선택 설정 제거 처리(기존 플레인 템플릿 서비스 종료)
        useFixedTemplate: false,
        headerPage: {
          // 한국향은 메인화면에서 페이지 노출 기능 사용 안함
          showOnlySelectedSection: false,
        },
        headerElement: {
          headerCategory: {
            // 한국향은 헤더 카테고리 사용안함
            enable: false,
            // 한국향은 세로형 타입 선택 못함
            enableVerticalType: false,
            // 한국향은 top -> left, left-> top 위치 이동 기능 사용못함
            enableComplexTypeSectionMove: false,
          },
          headerMenus: {
            enableVerticalType: false,
            enableComplexTypeSectionMove: false,
          },
          headerIcons: {
            enableVerticalType: false,
            enableComplexTypeSectionMove: false,
          },
        },
        footerElement: {
          footerPolicy: {
            // 한국향은 정책과 이용약관만 노출됨
            policies: ['term', 'policy'],
          },
        },
      },
    });
  }
}
